import React, { useEffect, useState } from "react";
import Styles from "./ConnectModalBanking.module.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Modal,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchInterestedCompanies,
  fetchMatchmakingResults,
  compareBothListingDetails,
} from "../../../../Redux/Slices/bankingSlice";
import Loader from "../../../../commons/Loader/Loader";
import { toast } from "react-toastify";
import { placeBid, withdrawBid } from "../../../../Services/ApiCalling/banking";
import SelfListingBox from "../../../Banking/ListingContainer/SelfListing/SelfListingBox";
import { ReactComponent as ExpandMoreIcon } from "../../../../assets/images/expandMoreIcon.svg";
import { ReactComponent as SquareIcon } from "../../../../assets/images/view.svg";
import ViewInjectionModal from "../ViewInjectionModal/ViewInjectionModal";
import ViewDrawalModal from "../ViewDrawalModal/ViewDrawalModal";
import ConnectionAcceptModal from "../../../../commons/PopupModal/BankingPopup/ConnectionAcceptModal/ConnectionAcceptModal";
import WithdrawModal from "../../../../commons/PopupModal/BankingPopup/WithdrawModal/WithdrawModal";
import { activeLoading } from "../../../../Redux/Slices/notificationSlice";
import {
  formatDateElement,
  formatDateType,
} from "../../../../commons/FormatDate";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";

const ConnectModalBanking = ({
  open,
  handleClose,
  data,
  activeListingId,
  selfListing,
  counterPartyListing,
  isConnectionAlreadyMade,
  handleOpenIndent,
  selfData,
  onWithdrawSuccess,
  activeFilter,
}) => {
  const dispatch = useDispatch();

  const [expanded, setExpanded] = useState(true);
  const [injectionModalOpen, setInjectionModalOpen] = useState(false);
  const [injectionData, setInjectionData] = useState([]);
  const [drawalModalOpen, setDrawalModalOpen] = useState(false);
  const [drawalData, setDrawalData] = useState([]);
  const [acceptModal, setAcceptModal] = useState(false);
  const [withdrawModal, setWithdraModal] = useState(false);
  const [isComparing, setIsComparing] = useState(false);
  const [compareResult, setCompareResult] = useState(null);

  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };

  const counterId = counterPartyListing?.id;

  const RotatingExpandIcon = () => (
    <ExpandMoreIcon
      style={{
        transform: expanded ? "rotate(90deg)" : "rotate(90deg)",
        transition: "transform 0.3s ease",
      }}
    />
  );

  const { interestedCompanies } = useSelector(
    (state) => state.bankingSlice || {},
  );

  const connectLoading = useSelector(
    (state) => state.notificationSlice?.loading || false,
  );

  const withdrawLoading = useSelector(
    (state) => state.notificationSlice?.loading || false,
  );

  const interestedCompaniesData = interestedCompanies?.data || [];
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    if (counterId) {
      dispatch(
        fetchInterestedCompanies({
          listingId: counterId,
          currentPage: 0,
          size: 10,
        }),
      );
    }
  }, [counterId, dispatch]);

  const counterPartyListingId = useSelector(
    (state) => state.bankingSlice.counterPartyListingId,
  );

  const selectedCounterparty = Array.isArray(data)
    ? data.find((item) => item.id === counterPartyListingId)
    : null;

  const handleConnectClick = async () => {
    if (!selectedCounterparty?.id) {
      console.warn("No selected counterparty found.");
      return;
    }

    const payload = {
      againstBankingListingId: selectedCounterparty.id,
      bankingListingId: activeListingId,
    };

    dispatch(activeLoading(true));

    try {
      await placeBid(payload);
      dispatch(
        fetchMatchmakingResults({
          id: activeListingId,
          statusFilter: activeFilter,
        }),
      );
      handleClose();
    } catch (err) {
      console.error("Error placing bid:", err);
      toast.error(err?.response?.data?.message || "Failed to connect");
    } finally {
      dispatch(activeLoading(false));
    }
  };

  const handleWithdrawClick = async () => {
    if (!counterPartyListing?.bidId) {
      console.warn("No bidId available to withdraw.");
      return;
    }
    dispatch(activeLoading(true));
    try {
      await withdrawBid(counterPartyListing.bidId);

      dispatch(
        fetchMatchmakingResults({
          id: activeListingId,
          statusFilter: activeFilter,
        }),
      );

      handleClose();
      if (onWithdrawSuccess) {
        onWithdrawSuccess();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to withdraw bid");
    } finally {
      dispatch(activeLoading(false));
    }
  };
  useEffect(() => {
    if (acceptModal) {
      handleCompareListings();
    }
  }, [acceptModal]);

  const handleCompareListings = async () => {
    const isInitiatorTermsByPass = selfListing?.termsByPass === true;
    const isCounterpartyTermsByPass = counterPartyListing?.termsByPass === true;

    if (isInitiatorTermsByPass && isCounterpartyTermsByPass) {
      setIsComparing(true);
      try {
        const result = await dispatch(
          compareBothListingDetails({
            listingId1: activeListingId,
            listingId2: selectedCounterparty?.id,
          }),
        ).unwrap();

        console.log("🚀 ~ handleCompareListings ~ result:", result);
        setCompareResult(result);
      } catch (compareError) {
        console.error("Error comparing listings:", compareError);
        toast.error("Failed to compare listings. Please try again.");
        setCompareResult(false);
        setAcceptModal(false);
      } finally {
        setIsComparing(false);
      }
    } else {
      setCompareResult(null);
    }
  };

  const handleAcceptClick = async () => {
    try {
      await handleConnectClick();
      setAcceptModal(false);
    } catch (error) {
      console.error("Error in handleAcceptClick:", error);
      toast.error(error?.message || "Failed to process request");
    }
  };

  const getConfirmationMessage = () => {
    const isInitiatorTermsByPass = selfListing?.termsByPass === true;
    const isCounterpartyTermsByPass = counterPartyListing?.termsByPass === true;

    if (
      isInitiatorTermsByPass &&
      isCounterpartyTermsByPass &&
      compareResult === true
    ) {
      return "Are you sure you want to send this connection request?";
    }

    return "Are you sure you want to send this connection request?";
  };

  const getConfirmationNote = () => {
    const isInitiatorTermsByPass = selfListing?.termsByPass === true;
    const isCounterpartyTermsByPass = counterPartyListing?.termsByPass === true;

    if (
      isInitiatorTermsByPass &&
      isCounterpartyTermsByPass &&
      compareResult === true
    ) {
      return "You are connecting to a 100% matched listing. Upon acceptance, the listing details will constitute the Final Terms & Conditions, and the parties may directly proceed with the required documentation.";
    }

    return null;
  };

  const formattedDT = (datetimeStr) => {
    if (!datetimeStr) return "";

    const [date, timeWithSeconds] = datetimeStr.split("T");
    if (!timeWithSeconds) return date.replace(/-/g, " ");
    return date.replace(/-/g, " ");
  };

  const formatTime = (datetimeStr) => {
    if (!datetimeStr) return "";

    const [date, timeWithSeconds] = datetimeStr.split("T");
    if (!timeWithSeconds) return date;

    let time = timeWithSeconds.substring(0, 5);
    if (time === "23:59") {
      time = "24:00";
    }
    return `${time}`;
  };

  const filteredOffers =
    interestedCompaniesData?.filter(
      (item) => item.name !== selfListing?.name,
    ) || [];

  return (
    <>
      <ViewInjectionModal
        open={injectionModalOpen}
        handleClose={() => setInjectionModalOpen(false)}
        data={injectionData}
      />

      <ViewDrawalModal
        open={drawalModalOpen}
        handleClose={() => setDrawalModalOpen(false)}
        data={drawalData}
      />

      <ConfirmationModal
        open={acceptModal}
        handleClose={() => !isComparing && setAcceptModal(false)}
        handleSubmit={handleAcceptClick}
        header="Connection Request"
        data={getConfirmationMessage()}
        note={getConfirmationNote()}
        loading={isComparing || connectLoading}
        customStyle={getConfirmationNote() ? { minHeight: "200px" } : {}}
      />

      {withdrawModal && (
        <WithdrawModal
          open={withdrawModal}
          handleClose={() => setWithdraModal(false)}
          onConfirm={async () => {
            await handleWithdrawClick();
            setWithdraModal(false);
          }}
          isInConnect={true}
          loading={withdrawLoading}
        />
      )}

      <Modal open={open} onClose={handleClose}>
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className={`headingText ${Styles.connectHead}`}>
              Connection Request
            </div>
            <Close
              style={{ fontSize: 24, color: "#777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>

          <div className={Styles.customMainContainer}>
            <div className={Styles.connectSubPart}>
              <div>
                {selfListing && (
                  <SelfListingBox
                    item={selfListing}
                    activeListingId={false}
                    alterButton={false}
                    handleOpenIndent={handleOpenIndent}
                    isInConnectModal={true}
                    isCounterparty={false}
                  />
                )}
              </div>
              <div className={Styles.nonClickable}>
                {counterPartyListing && (
                  <SelfListingBox
                    item={counterPartyListing}
                    activeListingId={false}
                    alterButton={false}
                    handleOpenIndent={handleOpenIndent}
                    isInConnectModal={true}
                    isCounterparty={true}
                  />
                )}
              </div>
            </div>

            {filteredOffers?.length > 0 && !isLoading && (
              <div className={Styles.connectThirdCont}>
                <Accordion
                  expanded={expanded}
                  onChange={handleChange}
                  className={Styles.accordionSummary}
                >
                  <AccordionSummary
                    expandIcon={<RotatingExpandIcon />}
                    aria-controls="panel-content"
                    id="panel-header"
                    className={Styles.accordionSummaryHeader}
                    sx={{
                      "&.Mui-expanded": {
                        minHeight: "32px",
                        height: "32px",
                        backgroundColor: "#F5FDFF",
                      },
                    }}
                  >
                    <div className={Styles.companyPart1}>Other Offers</div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className={Styles.companyPart2}>
                      <div
                        className={Styles.companyPartHead}
                        style={{ width: "13%" }}
                      >
                        Injection Range
                      </div>
                      <div
                        className={Styles.companyPartHead}
                        style={{
                          textAlign: "left",
                        }}
                      >
                        Min Injec. Qty
                      </div>
                      <div className={Styles.companyPartHead}>
                        Max Injec. Qty
                      </div>
                      <div
                        className={Styles.companyPartHead}
                        style={{
                          width: "21%",
                          textAlign: "left",
                        }}
                      >
                        Drawal Range
                      </div>
                      <div
                        className={Styles.companyPartHead}
                        style={{
                          textAlign: "left",
                        }}
                      >
                        Min Drawal Qty
                      </div>
                      <div
                        className={Styles.companyPartHead}
                        style={{
                          width: "10%",
                          textAlign: "left",
                        }}
                      >
                        Max Drawal Qty
                      </div>
                    </div>

                    <div className={`scroll_bar_y ${Styles.tableCompanyPart}`}>
                      {interestedCompaniesData
                        ?.filter((item) => item.name !== selfListing?.name)
                        .map((item) => (
                          <div className={Styles.tableElement} key={item.id}>
                            <div
                              className={`display_flex_column_gap_4 ${Styles.tableElementItem}`}
                            >
                              <span>
                                {formatDateType(item?.injectMinRange)} -{" "}
                                {formatDateType(item?.injectMaxRange)}
                              </span>
                              <span
                                style={{
                                  textAlign: "left",
                                  color: "var(--secondary-color-text",
                                  fontWeight: "450",
                                }}
                              >
                                {formatTime(item?.injectMinRange)} -{" "}
                                {formatTime(item?.injectMaxRange)}
                              </span>
                            </div>
                            <div
                              className={Styles.tableElementItem}
                              style={{
                                width: "10%",
                                textAlign: "left",
                              }}
                            >
                              {item?.minInjectQuantity}
                            </div>
                            <div
                              className={Styles.tableElementItem}
                              style={{
                                width: "9%",
                                textAlign: "left",
                              }}
                            >
                              {item?.maxInjectQuantity}
                            </div>
                            <div
                              className={`display_flex_column_gap_4 ${Styles.tableElementItem}`}
                              style={{
                                width: "21%",
                                textAlign: "left",
                              }}
                            >
                              <span>
                                {formatDateType(item?.drawalMinRange)} -{" "}
                                {formatDateType(item?.drawalMaxRange)}
                              </span>
                              <span
                                style={{
                                  textAlign: "left",
                                  color: "var(--secondary-color-text",
                                  fontWeight: "450",
                                }}
                              >
                                {formatTime(item?.drawalMinRange)} -{" "}
                                {formatTime(item?.drawalMaxRange)}
                              </span>
                            </div>
                            <div
                              className={Styles.tableElementItem}
                              style={{
                                textAlign: "left",
                                width: "12%",
                              }}
                            >
                              {item?.minDrawalQuantity}
                            </div>
                            <div
                              className={Styles.tableElementItem}
                              style={{
                                width: "9%",
                                textAlign: "left",
                              }}
                            >
                              {item?.maxDrawalQuantity}
                            </div>
                          </div>
                        ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            )}
          </div>

          <div className={Styles.connectionConnectButton}>
            {!isConnectionAlreadyMade ? (
              <div
                className={Styles.connectHeading}
                onClick={() => setAcceptModal(true)}
              >
                Connect
              </div>
            ) : (
              <div
                className={Styles.withdrawButton}
                onClick={() => setWithdraModal(true)}
              >
                Withdraw
              </div>
            )}
          </div>

          {isLoading && (
            <div className={Styles.loaderOverlay}>
              <Loader />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ConnectModalBanking;
